import React from 'react';
import styled from '@emotion/styled';

const LegendContainer = styled.div({
  position: 'absolute',
  bottom: '100px',
  right: '20px',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  padding: '12px 16px',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  zIndex: 1000,
  minWidth: '220px',
  fontSize: '12px',
  fontFamily: 'Arial, sans-serif',
});

const LegendTitle = styled.div({
  fontWeight: 'bold',
  marginBottom: '8px',
  fontSize: '13px',
  color: '#333',
});

const LegendItem = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '6px',
  '&:last-child': {
    marginBottom: 0,
  },
});

const ColorBox = styled.div(({ color }) => ({
  width: '30px',
  height: '4px',
  backgroundColor: color,
  marginRight: '8px',
  borderRadius: '2px',
}));

const LegendText = styled.span({
  color: '#555',
  fontSize: '11px',
});

const TrafficLegend = ({ show }) => {
  if (!show) return null;

  const legendItems = [
    { color: '#0066FF', label: '< 0.97 - Better than normal' },
    { color: '#00FF00', label: '0.97-1.03 - Normal traffic' },
    { color: '#FFFF00', label: '1.03-1.12 - Moderate (+3-12%)' },
    { color: '#FFAA00', label: '1.12-1.20 - Heavy (+12-20%)' },
    { color: '#FF0000', label: '> 1.20 - Severe (+20%+)' },
  ];

  return (
    <LegendContainer>
      <LegendTitle>Traffic Congestion</LegendTitle>
      {legendItems.map((item) => (
        <LegendItem key={item.label}>
          <ColorBox color={item.color} />
          <LegendText>{item.label}</LegendText>
        </LegendItem>
      ))}
    </LegendContainer>
  );
};

export default TrafficLegend;
